// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2rAJT","errorLogs":"EditorFooter_errorLogs__3u9Oc"};